// extracted by mini-css-extract-plugin
export default {"bord":"index_bord_aIuJz","tit":"index_tit_-dRJn","p10":"index_p10_5-ELP","listItem":"index_listItem_N1bjf","cRed3":"index_cRed3_EZ827","cBlue":"index_cBlue_9fwgy"};